export type IntlKeyValuePair = {
    key: string;
    defaultValue: string | ((...args: any[]) => string);
    intlValue: string;
    namespace: IntlNamspaces;
};

export enum IntlNamspaces {
    COMMON = "common",
    LOGIN = "login",
    SIGNUP = "signup",
    ACCOUNT_LOCKED = "accountLocked",
    PRIVACY_TEXT = "privacy-text",
    CODE_OF_CONDUCT = "codeOfConduct",
    ERROR_MESSAGE = "errorMessage",
    UNIVERSITY_CHAT = "universityChat",
    PASSWORD_RESET = "passwordReset",
}
